import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MoveShipmentOnPlanDto } from '@core/models/planner-models/move-shipment-on-plan.dto';
import { PlannerLoadingSearchDto } from '@core/models/planner-models/planner-loading-search.dto';
import { PlannerLoadingDto } from '@core/models/planner-models/planner-loading.response.dto';
import { OrderDto, PlannerRouteDto, VehicleDriverSetDto } from '@core/models/planner-models/planner.model';
import { SetTaskScaleStatusDto } from '@core/models/planner-models/set-task-scale-status.dto';
import { map, Observable } from 'rxjs';
import { DomainService } from '../domain.service';

@Injectable({
  providedIn: 'root'
})
export class PlannerNativeService {
  private _apiUrl: string = '';

  constructor(private readonly http: HttpClient,
    private _domainService: DomainService,
  ) {
    this._domainService.apiUrl$.subscribe((apiUrl: string) => {
      this._apiUrl = apiUrl;
    });
  }

  getDrivers(searchParams: { clientId: number, categoryIds: number[], regionsIds: number[] }): Observable<VehicleDriverSetDto[]> {
    return this.http.post<VehicleDriverSetDto[]>(`${this._apiUrl}admin/planner/drivers`, {
      ClientId: searchParams.clientId,
      CategoryIds: searchParams.categoryIds,
       RegionsIds: searchParams.regionsIds,
    })
  }

  getUnassignedOrders(searchParams: { clientId: number, categoryIds: number[], regionsIds: number[] }): Observable<OrderDto[]> {
    return this.http.post<OrderDto[]>(`${this._apiUrl}admin/planner/orders`, {
      ClientId: searchParams.clientId,
      CategoryIds: searchParams.categoryIds,
      RegionsIds: searchParams.regionsIds,
    })
  }

  getUnassignedShipments(searchParams: { clientId: number, categoryIds: number[], regionsIds: number[] }): Observable<OrderDto[]> {
    return this.http.post<OrderDto[]>(`${this._apiUrl}admin/planner/shipments`, {
      ClientId: searchParams.clientId,
      CategoryIds: searchParams.categoryIds,
      RegionsIds: searchParams.regionsIds,
    })
  }

  getDriversRoutes(searchParams: { fromDate: Date, toDate: Date, driversIds: number[], categoryIds: number[]  }): Observable<PlannerRouteDto[]> {
    return this.http.post<PlannerRouteDto[]>(`${this._apiUrl}admin/planner/driver-routes`, {
      FromDate: searchParams.fromDate,
      ToDate: searchParams.toDate,
      DriversIds: searchParams.driversIds,
      CategoryIds: searchParams.categoryIds
    }).pipe(map(resp => (resp.map(route => (
      {
        ...route,
        PlanTime: new Date(route.PlanTime),
        PlanEndTime: new Date(route.PlanEndTime),
      }
    )))));
  }

  getRoutesByIds(params: { plansIds: number[] }): Observable<PlannerRouteDto[]> {
    return this.http.post<PlannerRouteDto[]>(`${this._apiUrl}admin/planner/plans`, {
      PlanIds: params.plansIds,
    }).pipe(map(resp => (resp.map(route => (
      {
        ...route,
        PlanTime: new Date(route.PlanTime),
        PlanEndTime: new Date(route.PlanEndTime),
      }
    )))));
  }

  finishPlans(params: { plansIds: number[] }): Observable<any> {
    return this.http.post<any>(`${this._apiUrl}planning/logistic/finish`, {
      Plans: params.plansIds.map(id => ({ PlanId: id }))
    });
  }

  moveShipmentOnPlan(params: MoveShipmentOnPlanDto): Observable<any> {
    return this.http.post<any>(`${this._apiUrl}admin/planner/moveshipment`, params);
  }

  newShipmentByOrder(params: { OrderId: number }): Observable<any> {
    return this.http.post<any>(`${this._apiUrl}delivery/newshipmentbyorder`, params);
  }

  getLoadings(params: PlannerLoadingSearchDto): Observable<PlannerLoadingDto> {
    return this.http.post<PlannerLoadingDto>(`${this._apiUrl}planning/logistic/loadingsearch`, params);
  }

  setTaskScaleStatus(params: SetTaskScaleStatusDto): Observable<void> {
    return this.http.post<void>(`${this._apiUrl}planning/logistic/taskscalestatus`, params);
  }
}